// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"0639873b","63":"2169d431","425":"405bb1a2","592":"b9d3fb50","617":"88d4ab48","859":"8be64bc6"}[chunkId] + ".chunk.js";
};